import React, {Component} from 'react'
import './BackOfficeUserDetailCreateReceiptComponent.css'

export default class BackOfficeUserDetailCreateReceiptComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showForm: false,
            selectedOption: 'SPORTELLO_CONTANTI'
        };
    }

    handleOptionChange(changeEvent) {
        this.setState({
            selectedOption: changeEvent.target.value
        });
    }

    render() {
        return(<div style={{display: 'inline'}}>
            {!this.state.showForm && <a onClick={() => this.setState({showForm: true})} className="btn btn-info-user"><i className="glyphicon glyphicon-edit"></i>{} Emetti Ricevuta</a>}
            {this.state.showForm && <span>
                <div className="emetti-ricevuta">
                    <label>POS <input required onChange={this.handleOptionChange.bind(this)} checked={this.state.selectedOption === 'SPORTELLO_POS'} name="method" type="radio" value={"SPORTELLO_POS"} /></label>{' '}
                    <label>CONTANTI <input required onChange={this.handleOptionChange.bind(this)}  checked={this.state.selectedOption === 'SPORTELLO_CONTANTI'} name="method" type="radio" value={"SPORTELLO_CONTANTI"} /></label>
                </div>
                <div className="emetti-ricevuta">
                    <a onClick={() => this.props.onSubmit(this.state.selectedOption)} className="btn btn-success btn-xs btn-update btn-add-card"> <i className="glyphicon glyphicon-ok-circle"></i>{} Conferma</a>
                        {this.state.showForm && <a onClick={() => this.setState({showForm: false})} className="btn btn-danger btn-xs btn-update btn-add-card">
                        <i className="glyphicon glyphicon-remove-circle"></i>{} Annulla</a>}
                </div>
            </span>}
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/BackOfficeUserDetailCreateReceiptComponent.js